<template>
  <div v-loading="loading">
    <div class="d-flex">
      <div class="side-frame-success"></div>
      <div>
        <span style="font-size: 14px; color: #606266">
          {{ `NO: ${formData.pdProcessDictNo || 'New'}` }}
        </span>
        <el-divider direction="vertical"></el-divider>
        <el-tag
          size="mini"
          :type="
            formData.pdProcessDictStatus === 'D'
              ? 'danger'
              : formData.pdProcessDictStatus === 'S'
              ? 'warning'
              : formData.pdProcessDictStatus === 'Y'
              ? 'success'
              : ''
          "
        >
          {{ formData.v_pdProcessDictStatus || 'New' }}
        </el-tag>
        <el-divider direction="vertical"></el-divider>
        <span style="font-size: 14px; color: #606266">
          {{
            `Modify: ${formData.modifyByName ||
              '--'} at ${formData.modifyTime || '--'}`
          }}
        </span>
      </div>
    </div>
    <el-form
      ref="form"
      :model="formData"
      :disabled="disabled"
      :rules="rules"
      size="small"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_processDictName') || '字典名称'"
            prop="processDictName"
          >
            <el-input
              v-model.trim="formData.processDictName"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              style="width: 100%"
              maxlength="100"
            />
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_masterCategory') || '主分类'"
            prop="masterCategoryCode"
          >
            <dict-select
              v-model="formData.masterCategoryCode"
              :disabled="disabled || reviewEditDisabled"
              url="/master/masterCategory/select"
              :body="{ parentCode: 'ABSHome' }"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              @change="formData.categoryCode = ''"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_category') || '明细分类'">
            <dict-select
              v-model="formData.categoryCode"
              url="/master/masterCategory/select"
              :body="categoryParams"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              clearable
              filterable
              :disabled="!formData.masterCategoryCode || reviewEditDisabled || disabled"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('form_label_pdPerson') || '工艺师'"
            prop="pdPersonCode"
          >
            <dict-select
              v-model="formData.pdPersonCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              :selectedLabel.sync="formData.pdPersonName"
              clearable
              filterable
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item :label="$l('form_label_remark') || '备注说明'">
            <el-input
              v-model.trim="formData.remark"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              type="textarea"
              maxlength="1000"
              show-word-limit
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { mapState } from 'vuex'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    reviewEditDisabled: { type: Boolean, default: false },
    pdProcessDictCode: { type: String, default: '' },
  },
  data() {
    return {
      backDialogVisible: false,
      loading: false,
      formData: {},
      rules: {
        processDictName: [
          {
            required: true,
            message: this.$l('INDEX.tips_input_placeholder') || '请输入...',
            trigger: 'blur',
          },
        ],
        masterCategoryCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
        pdPersonCode: [
          {
            required: true,
            message: this.$l('INDEX.tips_select_data') || '请选择...',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    categoryParams() {
      const { masterCategoryCode } = this.formData
      return { parentCode: masterCategoryCode || 'x' }
    },
    ...mapState('admin/user', ['info']),
  },
  watch: {
    info: {
      handler(userInfo) {
        if (this.pdProcessDictCode) return
        if (!userInfo || userInfo === {}) return
        const { userCode, userName, userNameEn } = userInfo
        this.formData.pdPersonCode = userCode || ''
        this.formData.pdPersonName = [userNameEn, userName]
          .filter(Boolean)
          .join('-')
      },
      immediate: true,
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.pdProcessDictCode) return
      this.loading = true
      const res = await this.$api
        .processDictionaryDetailApi({
          pdProcessDictCode: this.pdProcessDictCode,
        })
        .catch(() => null)
      this.loading = false
      const { body } = res || {}
      this.formData = body || {}
    },
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return

      this.loadingOpen()
      const res = await this.$api
        .processDictionarySaveApi(this.formData)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status, body } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })

      if (this.pdProcessDictCode) {
        this.getData()
        return
      }

      const { pdProcessDictCode = '', pdProcessDictNo = '' } = body || {}
      if (pdProcessDictCode) {
        this.$router.replace({
          name: 'technology-processDictionary-detail',
          params: { pdProcessDictCode, pageType: 'edit' },
          query: { pdProcessDictNo },
        })
        return
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.side-frame-success {
  padding: 1px 5px;
  border-left: 3px solid $color-success;
  height: 20px;
  margin-top: 3px;
}
</style>
